export const iconFontAwesomeHumanitarianSquarePersonConfined = (
	<i className="fa-solid fa-square-person-confined"></i>
);
